module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-2@2-450a4c8d31e74e15eb2d4889f5ddf2f2.jpg";